import { axios } from "../../lib/axios";

type UpdateCouponStatusDTO = {
  id: string;
  isActive: boolean;
};

type UpdateCouponStatusResponse = {
  message: string;
  data: {
    id: string;
    isActive: boolean;
  };
};

export const UpdateCouponStatus = ({
  id,
  isActive,
}: UpdateCouponStatusDTO): Promise<UpdateCouponStatusResponse> => {
  return axios
    .patch(`/coupon/${encodeURIComponent(id)}/status`, { isActive })
    .then((response) => response.data as UpdateCouponStatusResponse);
};
